import Button                           from 'Common/Button/Button';
import React, { useCallback, useState } from 'react';
import { Drawer }                       from 'antd';

export const CustomSearchBarDrawer = ({ children, title, visible, onClose, onSearch, defaultValue }) => {
    const [ selectedElements, setSelectedElements ] = useState(defaultValue ?? []);

    const handleOnClose = useCallback(() => {
        onClose();
    }, []);

    const handleOnSubmit = useCallback(() => {
        onSearch(selectedElements);
        onClose();
    }, [selectedElements])

    const handleOnClearFilter = useCallback(() => {
        setSelectedElements([]);
        onSearch();
        onClose();
    }, [])

    const handleOnChange = useCallback((elements) => {
        setSelectedElements(elements)
    }, []);

    return (
        <Drawer open={visible} onClose={handleOnClose} width={640} title={title}>
            { children({ onChange: handleOnChange, value: selectedElements }) }
            <br />
            <br />
            <br />
            <Button onClick={handleOnSubmit} className={'width100'}>Filter übernehmen</Button>
            <br /><br />
            <Button danger onClick={handleOnClearFilter} className={'width100'}>Filter löschen</Button>
        </Drawer>
    );
};
